import React, { useState } from 'react'
import Modal from 'react-modal'
import { db } from '../..'
import { ref, push } from 'firebase/database'

const ReportModal = ({ isOpen, onClose, gameId, historyKey, historyItem, uid }) => {
    const [reportContent, setReportContent] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false)

    const customStyles = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1000
        },
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: '500px',
            width: '90%',
            borderRadius: '10px',
            padding: '0',
            overflow: 'hidden'
        },
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!reportContent.trim()) return

        setIsSubmitting(true)
        try {
            // 通報データを保存
            const reportRef = ref(db, `gameLogs/${gameId}/reports/${historyKey}`)
            await push(reportRef, {
                content: reportContent.trim(),
                reportedBy: uid,
                timestamp: Date.now(),
                reportedAt: new Date().toISOString()
            })

            // 成功時の処理
            setReportContent('')
            onClose()
            alert('通報が送信されました。')
        } catch (error) {
            console.error('通報送信エラー:', error)
            alert('通報の送信に失敗しました。')
        } finally {
            setIsSubmitting(false)
        }
    }

    const handleClose = () => {
        setReportContent('')
        onClose()
    }

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={handleClose}
            style={customStyles}
            contentLabel="通報"
        >
            <div className="bg-white">
                {/* ヘッダー */}
                <div className="bg-red-50 px-4 py-3 border-b flex justify-between items-center">
                    <h2 className="text-lg font-semibold text-red-700">
                        <i className="bi bi-flag-fill me-2"></i>通報
                    </h2>
                    <button
                        onClick={handleClose}
                        className="text-gray-500 hover:text-gray-700"
                    >
                        <i className="bi bi-x-lg"></i>
                    </button>
                </div>

                {/* 通報対象の情報 */}
                <div className="px-4 py-3 bg-gray-50 border-b">
                    <div className="text-sm text-gray-600 mb-1">通報対象</div>
                    <div className="font-medium text-gray-800">
                        {historyItem?.team?.name} - {historyItem?.missionTitle}
                    </div>
                    <div className="text-xs text-gray-500">
                        {historyItem?.time && new Date(historyItem.time).toLocaleString()}
                    </div>
                </div>

                {/* 通報フォーム */}
                <form onSubmit={handleSubmit} className="p-4">
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            通報理由・詳細
                        </label>
                        <textarea
                            value={reportContent}
                            onChange={(e) => setReportContent(e.target.value)}
                            placeholder="不適切な内容や規則違反について詳しく記載してください..."
                            className="w-full h-32 p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent resize-none"
                            required
                        />
                    </div>

                    <div className="text-xs text-gray-500 mb-4">
                        ※ 虚偽の通報は禁止されています。
                    </div>

                    <div className="flex gap-3">
                        <button
                            type="button"
                            onClick={handleClose}
                            className="flex-1 px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                            disabled={isSubmitting}
                        >
                            キャンセル
                        </button>
                        <button
                            type="submit"
                            className="flex-1 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 disabled:bg-gray-400"
                            disabled={isSubmitting || !reportContent.trim()}
                        >
                            {isSubmitting ? '送信中...' : '通報する'}
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    )
}

export default ReportModal